import { useConfirmContext, type ChoiceOptions, type ConfirmOptions } from '@sorrem-client/ui/components';

interface ConfirmState {
    confirm: (options: ConfirmOptions) => Promise<boolean>;
    choose: (options: ChoiceOptions) => Promise<string | null>;
}

/**
 * Provides promise-based confirmation prompts for important user actions.
 */
export function useConfirm(): ConfirmState {
    const { confirm, choose } = useConfirmContext();

    return {
        confirm,
        choose,
    };
}
